export default __webpack_public_path__ + "static/media/property-red.33503855.svg";